import {rootState} from '@mintdata-wsp/common/state/RootState';
import {controllers} from '@mintdata-wsp/wsp/controllers/WspControllers';
import {UserIcon, UserIconSize} from '@mintdata-wsp/wsp/ui/views/visualDesigner/header/userPresence/UserIcon';
import {UserPlusIcon} from '@mintdata-wsp/wsp/ui/views/visualDesigner/header/userPresence/UserPlusIcon';
import * as classnames from 'classnames/bind';
import {action} from 'mobx';
import {observer} from 'mobx-react';
import React from 'react';
import {ActiveUserEvent} from '@mintdata-wsp/wsp/controllers/multiplayer/MultiplayerController';

const styles = require('./TopBarUserIconList.less');
const cx = classnames.bind(styles);

interface TopBarActiveUsersListProps
{
    iconSize:UserIconSize;
    className?:string;
    wspMode?:boolean;

    userIconContainerClassName?:string;
}

@observer
export class TopBarUserIconList extends React.Component<TopBarActiveUsersListProps>
{
    public static readonly MAX_TOPBAR_VISIBLE_USERS = 5;

    public render():JSX.Element
    {
        const {iconSize, className, wspMode, userIconContainerClassName} = this.props;
        const {activeUsers} = rootState.ui.visualDesigner;

        if( !activeUsers.otherUsers || !activeUsers.otherUsers.length )
            return null;

        let users:ActiveUserEvent[] = [];
        activeUsers.otherUsers.forEach(user => {
            if( user.userId != rootState.userSession.currentUser.id && !users.map(user => user.userId).includes(user.userId) )
                users.push(user);
        });

        // TODO: for debug -> comment 4 lines above
        // const users = [{userId: 1}, {userId: 2}, {userId: 3}, {userId: 4}, {userId: 5}];

        if( users.length <= TopBarUserIconList.MAX_TOPBAR_VISIBLE_USERS )
        {
            return <div className={cx('userIconContainer', className)}>
                {
                    users.map((user) =>
                    {
                        const userDetails = activeUsers.otherUsersDetails.get(user.userId);

                        // TODO: for debug -> comment 1 line above
                        // const userDetails:IActiveUserDetails = {
                        //     fullName: 'a s',
                        //     avatarUrl: '',
                        //     color: ['#f00', '#00f', '#ff0', '#ff0', '#f0f', '#0ff'][Math.floor(Math.random() * 6)],
                        //     isIdle: !!Math.floor(Math.random() * 2),
                        //     idleHandlerId: null,
                        //     lastUpdated: null
                        // };

                        if( !userDetails )
                            return null;

                        return <UserIcon
                            key={`${wspMode && 'wsp_'}usericon_${user.userId}`}
                            iconSize={iconSize}
                            fullName={userDetails.fullName}
                            avatarUrl={userDetails.avatarUrl}
                            color={userDetails.color}
                            idle={userDetails.isIdle}
                            userId={user.userId}
                            selected={user.userId === activeUsers.followingUserId}
                            tooltip
                            onClick={this._handleUserIconClick}
                            userIconContainerClassName={userIconContainerClassName}
                        />;
                    })
                }
            </div>;
        }
        else
        {
            const userIcons = [];
            for( let i = 0; i < TopBarUserIconList.MAX_TOPBAR_VISIBLE_USERS; i++ )
            {
                const user = users[i];
                const userDetails = activeUsers.otherUsersDetails.get(user.userId);

                if( !userDetails )
                    return null;

                userIcons.push(<UserIcon
                    key={user.userId}
                    iconSize={iconSize}
                    fullName={userDetails.fullName}
                    avatarUrl={userDetails.avatarUrl}
                    color={userDetails.color}
                    userId={user.userId}
                    idle={userDetails.isIdle}
                    selected={user.userId === activeUsers.followingUserId}
                    tooltip
                    onClick={this._handleUserIconClick}
                />);
            }

            const plusUserCount = activeUsers.otherUsers.length - TopBarUserIconList.MAX_TOPBAR_VISIBLE_USERS;

            if( users.length )
                userIcons.push(<UserPlusIcon
                    key={'plus'}
                    iconSize={iconSize}
                    count={plusUserCount}
                    wspMode={wspMode}
                />);

            return <div className={cx('userIconContainer') + ' ' + className}>{userIcons}</div>;
        }
    }

    @action.bound
    _handleUserIconClick(userId:number)
    {
        if( this.props.wspMode )
            return;

        const {activeUsers} = rootState.ui.visualDesigner;
        const {activeUsersSync} = controllers.ui;

        if( activeUsers.followingUserId === userId )
        {
            activeUsersSync.stopFollowing();
        }
        else
        {
            activeUsers.followingUserId = userId;
            activeUsersSync.updateFollowingState();
        }
    }

}
